import { useEffect, useState } from 'react';
import { subscribeUrlWaveform } from '@/services/urlWaveform';
import type { WaveformState } from '@/services/waveformService';

/**
 * Seek-bar waveform for an audio file at a plain URL (blob:, same-origin stream, CDN); see subscribeUrlWaveform.
 * `null` until the peaks land, and forever when the file can't be decoded or is too big -- the caller draws its bar either way.
 */
export function useUrlWaveform(src: string | null | undefined): WaveformState | null {
  const [state, setState] = useState<WaveformState | null>(null);

  useEffect(() => {
    if (!src) { setState(null); return undefined; }
    return subscribeUrlWaveform(src, setState);
  }, [src]);

  return state;
}
